import * as R from 'ramda';
import intl from 'react-intl-universal';

import { IOneImage } from './Common';
import { maxNumberByType } from '../ComponentNavigator/AllForBottom';

export default function (props: IOneImage) {
  const showAlert = R.pathOr(R.T, ['rootStore', 'uiStore', 'showAlert'], props);
  const type = props.jigsaw?.type;
  const { jigsaw, id, onClick = R.T } = props;
  let checkShow = false;
  let index = -1;
  let disabled = false; //当前项是否应该disabled掉
  if (jigsaw) {
    if (!id) {
      console.warn('id is null here, should not be', id);
    }
    checkShow = jigsaw.bottomShow;
    if (checkShow) {
      const { jigsawList, type } = jigsaw;
      index = jigsawList.findIndex((one) => one.id === id);
      const maxLen = maxNumberByType(type);
      if (jigsawList.length >= maxLen) {
        disabled = index === -1; // 没找到的就disabled掉
      }
    }
  } else {
    // console.log('no jigsaw. Maybe you do not need it');
  }

  return {
    checkShow,
    index,
    disabled,
    onClick(...args: any[]) {
      if (disabled) {
        switch (type) {
          case 'download':
            onClick(...args);
            break;
          case 'share':
            //  MAX_SHARE_NUM
            showAlert({
              content: intl.get('MAX_SHARE_NUM', {
                num: maxNumberByType('share'),
              }),
            });
            break;
          default:
            console.log('no type');
            onClick(...args);
            break;
        }
        return;
      }
      onClick(...args);
    },
  };
}
